export const DATA_MISSING_TEXT = 'Data missing';
